import { gql } from '__generated__';

export default gql(`
  mutation EditParticipantAttribute($input: EditParticipantAttributeInput!) {
    editParticipantAttribute(input: $input) {
      ...GetFieldsEvent
    }
  }
`);
